import React from "react";
import { Language } from "../../components";

const LanguagePage = () => {
  return (
    <React.Fragment>
      <h2 className={"content-block"}>Languages</h2>
      <div className={"content-block"}>
        <Language />
      </div>
    </React.Fragment>
  );
};

export default LanguagePage;
